<template>
    <form @submit.prevent="onSubmit" v-if="form_data" class="auction-sites-form">
        <messages :messages="messages"/>
        <div class="">
            <div class="row">
                <template v-for="day in [1,2,3,4,5,6,7]">
                    <div v-if="form_data[day]" class="col-md-2">
                        <h4>{{getDayName(day)}}</h4>
                        <ul>
                            <li v-for="auction in form_data[day]">
                                <b-form-group class="col-md-12 vue-checkbox"
                                              :label="auction.auc_name"
                                              :label-for="getId(auction)">
                                    <b-form-checkbox
                                        :value="1"
                                        :id="getId(auction)"
                                        v-model="auction.active">
                                    </b-form-checkbox>
                                </b-form-group>
                            </li>
                        </ul>
                    </div>
                </template>
            </div>
        </div>
        <button type="submit" class="btn btn-default">Save</button>
    </form>
</template>
<script>
    import api from '../../api/api_resource';
    import messages from '../Messages'
    export default {
        props: [
            'user'
        ],
        components: {
            messages
        },
        data() {
            return {
                messages: [],
                form_data: {}
            }
        },
        created() {
            this.getData()
            this.form_data = this.value;
        },
        computed: {
        },
        methods: {
            onSubmit: function () {
                return new Promise((success, reject) => {
                    const form_data = {
                        auction_sites: Object.values(this.form_data).flat(),
                        user_id: this.user ? this.user.id : null
                    }
                    api.post('auction-sites.update', [], form_data).then(result => {
                        this.messages = [{message: result.message, type: 'success'}];
                    }).catch(error => {
                        this.messages = [{message: error.message, type: 'danger'}];
                    });
                });
            },
            async getData(){
                try {
                    let url = this.$laravelRoute('auction-sites.index')

                    if (this.user){
                        url += '?user_id=' + this.user.id
                    }
                    let res = await this.axios.get(url)
                    console.log(res)
                    if (res.data && res.data.auction_sites) {
                        this.form_data = res.data.auction_sites
                    }
                } catch (e) {
                    console.warn('error getting settings', e)
                }
            },
            getDayName(day_num){
                const days = {
                    1: 'Monday',
                    2: 'Tuesday',
                    3: 'Wednesday',
                    4: 'Thursday',
                    5: 'Friday',
                    6: 'Saturday',
                    7: 'Sunday',
                }
                return days[day_num] || 'err'
            },
            getId(auction){
                return `auction_${auction.auc_site_id}`
            }
        },
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/Forms/AuctionSites.vue